import Modal2 from 'components/commons/modal/Modal2';
import React from 'react';

export const ConfirmQuitModal = ({
  hide,
  isShowModal,
  onQuit,
  onContinue,
  modalType,
}: {
  isShowModal: boolean;
  hide: () => void;
  onQuit: () => void;
  onContinue: () => void;
  modalType: 'button' | 'header';
}): React.ReactElement => {
  const buttonWord = [
    '入力内容を破棄して戻りますか？',
    '「資産目標サポートTOP」へ戻ると入力した内容は破棄されます。',
    '入力内容を破棄して戻る',
  ];

  const headerWord = [
    '入力内容を破棄して「目標の設定」に戻りますか？',
    '「目標の設定」に戻ると入力した内容は破棄されます。',
    '入力内容を破棄して「目標の設定」に戻る',
  ];

  const sentence = modalType === 'button' ? buttonWord : headerWord;

  return (
    <>
      <Modal2 isShow={isShowModal} close={hide}>
        <div className="p-4">
          <div className="flex flex-col max-h-modal overflow-y-auto">
            <div
              className="icon-close text-gray-500 text-sm ml-auto cursor-pointer"
              onClick={hide}></div>
            <div className="flex flex-row items-start">
              <div className="font-bold text-bluegray-700 text-lg">
                {sentence[0]}
              </div>
            </div>
            <div className="flex flex-row mt-4 text-bluegray-700 text-sm">
              <div className="icon-alert items-start mr-2 mt-1 text-yellow-375"></div>
              <div>{sentence[1]}</div>
            </div>
            <div className="p-4 mt-4 flex flex-col">
              <button
                className="text-white rounded-lg bg-tradewell font-bold py-2 flex flex-row items-center justify-center text-base"
                onClick={onContinue}>
                入力を続ける
              </button>
              <button
                className="text-sm text-bluegray-500 py-2 flex flex-row items-center justify-center mt-2"
                onClick={onQuit}>
                {sentence[2]}
              </button>
            </div>
          </div>
        </div>
      </Modal2>
    </>
  );
};
